import { LOCAL_STORAGE } from "../utils/constant";

export const isAnyBidEnable = (custNo) => {
    const enableClients = [1123];
    return enableClients.includes(Number(custNo));
};

export const isBillingPartyEnable = (custNo) => {
    const enableClients = [1183];
    return enableClients.includes(Number(custNo));
};

export const isBillingPartyBranchRequired = () => {
    const enableClients = [549];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};

export const isProductFieldisRequired = () => {
    const enableClients = [549];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};

export const EnablePerKgRateRateChart = () => {
    const enableClients = [1330];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};
export const isTransportAllocationRequired = () => {
    const enableClients = [503, 549, 1568];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};